import React, { useEffect, useState } from 'react';
import { Box, Link, TableCell, TableRow, Typography } from '@mui/material';
import moment from 'moment/moment';

// COMPONENTS
import CardWrapper from '../../CardWrapper';
import Loader from '../../../common/Loader';
import DashboardTable from '../../DashboardTable';

// MESSAGES
import HomeFormattedMessages from '../../../../messages/HomeFormattedMessages';

// REQUESTS
import useDashboardRequest from '../../../../requests/DashboardRequest';

// UTILS
import { getZoneOffsettedDate } from '../../../../utils/dates';

export default function Invoices({ navigate, customer, errorHandler }) {
  const [invoiceData, setInvoiceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getCustomerLastInvoices } = useDashboardRequest();

  const columns = [
    { id: 'date', label: 'Date' },
    { id: 'total', label: 'Invoice Total', align: 'right' },
  ];

  const loadData = async () => {
    const response = await getCustomerLastInvoices(errorHandler);
    setInvoiceData(response);
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <CardWrapper
      title={HomeFormattedMessages.invoices}
      icon="invoice"
      goToLink="/billing/invoices"
      goToLinkState={{ customerName: customer.customer_name }}
      goToLinkText="Go to Invoices"
      navigate={navigate}
    >
      {loading ? (
        <Loader />
      ) : invoiceData.length === 0 ? (
        <Box sx={{ marginTop: 2 }}>
          <Typography>{HomeFormattedMessages.noDataAvailable}</Typography>
        </Box>
      ) : (
        <Box>
          <DashboardTable columns={columns}>
            {invoiceData.map((item, index) => (
              <TableRow key={`row_${index}`}>
                <TableCell>
                  <Link
                    href={`/billing/invoiceshow/${item.customer_id}/${item.bill_id}`}
                  >
                    {moment(new Date(getZoneOffsettedDate(item.Date))).format(
                      'DD-MMM-YYYY'
                    )}
                  </Link>
                </TableCell>
                <TableCell align="right">
                  {item['Invoice Total'] || 0}
                </TableCell>
              </TableRow>
            ))}
          </DashboardTable>
        </Box>
      )}
    </CardWrapper>
  );
}
